import { TableCellContentProps } from "ds/components/Table/Row/CellContent";
import IacManagementTableCell from "views/Account/IacManagement/components/Table/Row/Cell";
import useIacTableStore from "views/Account/IacManagement/components/Table/useIacTableStore";

import { RenderResourceRowCellProps } from "../../TableResourceRow";

type IacManagementResourceCellProps = Pick<RenderResourceRowCellProps, "cellId" | "isFirst"> &
  Pick<TableCellContentProps, "children" | "actions" | "role" | "stickyRight">;

const IacManagementResourceCell = ({
  cellId,
  role,
  isFirst,
  actions,
  children,
}: IacManagementResourceCellProps) => {
  const isFirstColumnPinned = useIacTableStore((state) => state.isFirstColumnPinned);

  return (
    <IacManagementTableCell
      id={cellId}
      role={role}
      stickyLeft={isFirst && isFirstColumnPinned}
      actions={actions}
    >
      {children}
    </IacManagementTableCell>
  );
};

export default IacManagementResourceCell;
